import api from "../services/api";
import { APIS } from "../endpoints";

/**
 * This function return songs data
 * @returns {Promise<Object>} - Function return Songs data
 */

// export const getArchiveData = async (limit, page) => {
//     const response = await getArchiveAPIData(limit, page);
//     return response;
// };

export const getAllInsightsData = async (limit, page, searchTerm) => {
    const formData = new FormData();
    formData.append('page', page);
    formData.append('limit', limit);

    if (searchTerm) {
        formData.append('search', searchTerm); // Add search term
    }

    const params = new URLSearchParams(formData);
    const result = await api.get(`${APIS.BASE_URL}${APIS.insights}`, {
        params: params
    })

    if (result) {
        return result?.data;
    } else {
        return [];
    }
};

export const getInsightData = async (alias) => {
    // Construct the endpoint URL conditionally based on the presence of `section`
    const endpoint = `${APIS.BASE_URL}admin/insights/${alias}`;

    try {
        const result = await api.get(endpoint);

        // Return the `data` if the result exists, otherwise return an empty array
        return result?.data?.data || [];
    } catch (error) {
        console.error('Error fetching libraries data:', error);
        return [];
    }
};

export const updateInsightData = async (alias, data, deletedValues) => {

    const payload = {
        ...data,
        deletedValues: deletedValues
    };

    const result = await api.put(`${APIS.BASE_URL}admin/insights/${alias}`, payload)

    if (result) {
        return result?.data;
    } else {
        return [];
    }
};

export const createNewInsight = async (data) => {

    const result = await api.post(`${APIS.BASE_URL}admin/insights`, data)

    if (result) {
        return result?.data;
    } else {
        return [];
    }
}